module.exports = __webpack_public_path__ + "static/media/preloader.780716cc.gif";